import type { AdlSunsetNudgeSource } from '../events'
import { trackAnalyticsEvent } from '../track'

interface AdlSunsetNudgeParams {
  source: AdlSunsetNudgeSource
  // Only the `market_page` surface carries market context; the dashboard nudge
  // is global ("at least one position") and omits these.
  chainId?: number
  marketId?: string
}

function buildProperties({ source, chainId, marketId }: AdlSunsetNudgeParams) {
  return {
    source,
    ...(chainId !== undefined ? { chain_id: chainId } : {}),
    ...(marketId !== undefined ? { market_id: marketId.toLowerCase() } : {})
  }
}

/** Impression — fired once when the sunset nudge modal opens, on either surface. */
export function trackAdlSunsetNudgeViewed(params: AdlSunsetNudgeParams) {
  trackAnalyticsEvent('adl_sunset_nudge_viewed', buildProperties(params))
}

/** "Learn more" pressed inside the nudge modal (both surfaces). */
export function trackAdlSunsetNudgeLearnMoreClicked(params: AdlSunsetNudgeParams) {
  trackAnalyticsEvent('adl_sunset_nudge_learn_more_clicked', buildProperties(params))
}

/**
 * "Got it" pressed in the dashboard nudge: the dashboard primary CTA
 * (acknowledge). Dashboard-only, so it carries no market context.
 */
export function trackAdlSunsetNudgeGotItClicked() {
  trackAnalyticsEvent('adl_sunset_nudge_got_it_clicked', { source: 'dashboard' })
}

/**
 * "Disable Auto-Deleverage" pressed in the market-page nudge — the conversion
 * entry point. Market-only, so market context is always present.
 */
export function trackAdlSunsetNudgeDisableClicked(params: { chainId: number; marketId: string }) {
  trackAnalyticsEvent('adl_sunset_nudge_disable_clicked', {
    source: 'market_page',
    chain_id: params.chainId,
    market_id: params.marketId.toLowerCase()
  })
}
